import { isNull } from 'lodash-es'
import { useState } from 'react'

import { cn } from '@/shared/lib'
import { Button, Dialog } from '@/shared/ui'

import { DIALOG } from '../../../lib/contract-dialog'
import { useContract } from '../contract-information/provider'

type DialogProps = {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}

export const CheckExtendContractDialog = ({
  isOpen,
  onOpenChange,
}: DialogProps) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content className={cn('h-[347px] gap-0 p-0')}>
        <ExtendContractDialogContent />
      </Dialog.Content>
    </Dialog.Root>
  )
}

export const ExtendContractDialogContent = () => {
  const [extend, setExtend] = useState<boolean | null>(null)

  const { openDialog } = useContract()

  const handleCheckBoxClick = (value: boolean) => {
    setExtend(value)
  }

  const handleRequestButtonClick = () => {
    if (isNull(extend)) {
      return
    }

    if (extend) {
      openDialog(DIALOG.END_DATE_CALENDAR, { closeOnOpen: true })
    } else {
      openDialog(DIALOG.PERIOD_CALENDAR, { closeOnOpen: true })
    }
  }

  return (
    <>
      <Dialog.Header className="p-6 pb-4">
        <Dialog.Title className="text-start">
          계약을 연장하시겠습니까?
        </Dialog.Title>
      </Dialog.Header>

      <div className="space-y-6 px-6">
        <div className="typo-label1 h-11 font-normal text-gray-900">
          <p>
            <span className="text-purple-500">이미 계약하신 방</span>입니다.
          </p>
          <p>기존 계약을 연장하거나, 새로운 계약을 시작해 주세요.</p>
        </div>

        <div className="flex gap-3">
          <CheckBox
            title="새로 계약하기"
            description={'기존 계약과\n별도로 계약할 경우'}
            value={false}
            selected={extend === false}
            onClick={handleCheckBoxClick}
          />
          <CheckBox
            title="계약 연장하기"
            description={'기존 계약에\n이어서 계약할 경우'}
            value={true}
            selected={extend === true}
            onClick={handleCheckBoxClick}
          />
        </div>
      </div>

      <Dialog.Footer className="p-6">
        <Button
          type="button"
          variant="solid"
          color="primary"
          size="large"
          fullWidth
          disabled={isNull(extend)}
          onClick={handleRequestButtonClick}
        >
          요청하기
        </Button>
      </Dialog.Footer>
    </>
  )
}

type CheckBoxProps = {
  title: string
  description: string
  value: boolean
  selected: boolean
  onClick: (value: boolean) => void
}

export const CheckBox = ({
  title,
  description,
  value,
  selected,
  onClick,
}: CheckBoxProps) => {
  const handleClick = () => {
    onClick(value)
  }

  return (
    <button
      className={cn(
        'flex h-[116px] grow cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border border-transparent bg-gray-50 p-6',
        'transition-colors hover:bg-gray-100',
        {
          'border-black bg-purple-50 hover:bg-purple-50': selected,
        },
      )}
      onClick={handleClick}
    >
      <p className="typo-label2 font-normal whitespace-break-spaces text-gray-500">
        {description}
      </p>
      <p className="typo-body1 font-medium text-black">{title}</p>
    </button>
  )
}
